import { roomEvents } from "@closerplatform/closer-sdk";
import { getParent, Instance } from "mobx-state-tree";
import { Conversation } from "../base/Conversation";
import { roomStoreGetter } from "../utils";

/**
 * Item in inbox. Extends Conversation.
 */
export const InboxEntry = Conversation.named("InboxEntry")
  .views(roomStoreGetter)
  .views((self) => {
    const views = {
      /**
       * The filter the entry is currently in
       */
      get filter() {
        // no idea here what is the type, maybe InboxFilter
        // FIXME: typed as any to avoid circular imports
        return getParent(self, 2);
      },
      /**
       * Checks if entry matches the currently selected room,
       * and should the entry be highlighted as selected.
       */
      get isSelected() {
        const currentRoom = self.roomStore && self.roomStore.currentRoom;
        return currentRoom && currentRoom.id === self.roomId;
      }
    };
    return views;
  })
  .actions((self) => {
    const actions = {
      onRoomMessageReceived(event: roomEvents.MessageSent) {
        self.udpateFromChatMessage(event);
      },

      onRoomCustomMessageReceived(event: roomEvents.CustomMessageSent) {
        self.udpateFromChatCustomMessage(event);
      }
    };

    return actions;
  });

export interface IInboxEntry extends Instance<typeof InboxEntry> {}
